export default {
  GET_RM(state, payload) {
    state.rmrecord = payload;
  },
  GET_RM_LIST(state, payload) {
    state.rmrecordlist = payload;
  },
  GET_RM_CONTACT(state, payload) {
    state.assignmono = payload;
  },
  GET_ASSIGN_RM_NAME(state, payload) {
    state.assignrmname = payload;
  },
  GET_ASSIGN(state, payload) {
    state.getassigned = payload;
  },
  CHECK_STATUS(state, payload) {
    state.checkStatus = payload;
  },
  CHECK_ASSIGN_STATUS(state, payload) {
    state.assignStatus = payload;
  },
  COMMIT_ALL_ASSIGN_USER(state, payload) {
    state.allassignagent = payload;
  },
  COMMMIT_ALL_NUMBER(state, payload) {
    state.checknumber = payload;
  },
  SET_FiILTER_STATUS(state, payload) {
    state.statusFilter = payload;
  },
};
